import { isBuild } from '@/const/host';

let comeinUrl;
let fileViewerUrl;
let mobileUrl;
let irPCUrl;

// 环境区分
if (isBuild) {
	mobileUrl = 'https://mobile.comein.cn';
	irPCUrl = 'https://irm-enterprise-pc.comein.cn';
	comeinUrl = 'https://server.comein.cn/comein';
	fileViewerUrl = 'https://file-view.comein.cn/onlinePreview?url=';
} else {
	mobileUrl = 'https://testmobile.comein.cn';
	irPCUrl = 'https://irm-enterprise-pc-test.comein.cn';
	comeinUrl = 'https://testserver.comein.cn/comein';
	fileViewerUrl = 'https://file-view-test.comein.cn/onlinePreview?url=';
}

export const MOBILE_URL = mobileUrl;
export const IR_PC_URL = irPCUrl;
export const COMEIN_URL = comeinUrl;
export const FILE_VIEWER_URL = fileViewerUrl;
